import { render, staticRenderFns } from "./MarketingAutomationDetailHeader.vue?vue&type=template&id=285b746e&scoped=true"
import script from "./MarketingAutomationDetailHeader.vue?vue&type=script&lang=js"
export * from "./MarketingAutomationDetailHeader.vue?vue&type=script&lang=js"
import style0 from "./MarketingAutomationDetailHeader.vue?vue&type=style&index=0&id=285b746e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "285b746e",
  null
  
)

export default component.exports